
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";

import api from "@/api";
import { OrganizationUnitDto } from "@/api/appService";
import { ElForm } from "element-ui/types/form";

@Component
export default class EditBaseCard extends Vue {
  @Ref() dataForm!: ElForm;
  defaultData: OrganizationUnitDto = {
    diffCardEnable:undefined,
    id: 0
  };

  show = false;
  form: OrganizationUnitDto | undefined = { ...this.defaultData };

  get cardDialogTitle() {
    return "设置 补差卡";
  }

  async created() {
    await this.fetchData();
  }
  // 获取数据
  async fetchData() {
    let param = {
      id: (this.$store.getters['user/ouId'])
    };
    await api.organizationUnit
      .getOrganizationUnit(param)
      .then(res => {
        console.log(res);
        this.form = res!;
      });
  }

  handle_activeOrUnActive(){
    console.log(123)
    let orgId = this.$store.getters['user/ouId'];
    let promise ;
    if(this.form?.diffCardEnable==true){
      promise = api.organizationUnit.diffCardOpen({body:{id:orgId}})
    } else {
      promise = api.organizationUnit.diffCardClose({body:{id:orgId}})
    }
    promise.then(res=>{
      if(this.form?.diffCardEnable==true){
        this.$message.success('补差卡已被启用')
      } else {
        this.$message.warning( '补差卡已被禁用');
      }
    })

  }

  async save() {
    console.log(this.form);
    if(this.form?.diffCardEnable==true){
      await api.organizationUnit.diffCardOpen({ body: this.form });
    }

  }

  roleRule = {
    name: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
